import { getApiBaseUrl, safeApiRequest } from './apiClient';

export const fetchPublicLegalPage = async (slug) => {
  const res = await fetch(`${getApiBaseUrl()}/api/public/legal/${slug}`);
  return res.json();
};

export const fetchAdminLegalPages = async () => safeApiRequest('/api/admin/legal-pages', { method: 'GET', skipCsrf: true });

export const updateAdminLegalPage = async (slug, payload) => safeApiRequest(`/api/admin/legal-pages/${slug}`, {
  method: 'PUT',
  body: payload,
  skipCsrf: false,
});
